import { createContext, useContext } from "react";
interface SwitchAccountContextProps {
  setSwitchingAccount: (state: boolean) => void;
  switchingAccount: boolean;
}

const SwitchAccountContext = createContext<SwitchAccountContextProps>({
  setSwitchingAccount: () => undefined,
  switchingAccount: undefined
});

export const useSwitchAccount = () => useContext(SwitchAccountContext);

export default SwitchAccountContext;
